var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ckeditor',{attrs:{"editor":_vm.editor},on:{"input":_vm.handleInput,"ready":_vm.ckEditorReady}})
}
var staticRenderFns = []

export { render, staticRenderFns }